export enum Type {
  SET_CREDIT_PULL_TEST_CASE = 'SET_CREDIT_PULL_TEST_CASE',
  SET_FINICITY_TEST_CASE    = 'SET_FINICITY_TEST_CASE',
  TOGGLE_REFER_TO_LO_BYPASS = 'TOGGLE_REFER_TO_LO_BYPASS',
}
